import {
  CurrencyValue,
  PercentageValue,
  formatNumber,
  formatPercentage,
  LineChart
} from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useChartPeriod } from '@/hooks';

export default function HistoricGraphs({
  data,
  timeFilter,
  chartDaysAgo,
  activeDisplayOption
}) {
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  const yScaleValueFormatter = useMemo(() => {
    return (value) => {
      switch (activeDisplayOption) {
        case 'supply_rate_apy':
          return `${formatPercentage(value)}`;
        default:
          return `${formatNumber(value)}`;
      }
    };
  }, [activeDisplayOption]);

  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      switch (activeDisplayOption) {
        case 'supply_rate_apy':
          return <PercentageValue value={Number(value)} />;

        case 'revenue':
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: 'USD'
              }}
            />
          );

        default:
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: {
                  name: data[0].underlying_symbol,
                  address: data[0].underlying_address
                },
                iconSize: '3'
              }}
            />
          );
      }
    }

    return formatValue;
  }, [activeDisplayOption, data]);

  return (
    <LineChart
      key={activeDisplayOption}
      data={data}
      datasets={[
        {
          xField: 'date',
          yField: activeDisplayOption
        }
      ]}
      yScaleValueFormatter={yScaleValueFormatter}
      valueFormatter={valueFormatter}
      timeFilter={timeFilter}
      config={config}
    />
  );
}
